export default __webpack_public_path__ + "static/media/bkg--design-1.2b19a6fa.jpg";